module.exports = __webpack_public_path__ + "static/media/qr_square_without_qr.d5d946e7.jpg";